var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.5 15.0758C27.5 8.13 21.9042 2.5 15 2.5C8.09583 2.5 2.5 8.13 2.5 15.0758C2.5 21.3542 7.07 26.5567 13.0467 27.5V18.7117H9.87333V15.075H13.0467V12.305C13.0467 9.15333 14.9125 7.41167 17.7683 7.41167C19.135 7.41167 20.5667 7.6575 20.5667 7.6575V10.7525H18.9892C17.4367 10.7525 16.9533 11.7225 16.9533 12.7175V15.0758H20.42L19.8658 18.7108H16.9533V27.5C22.93 26.5567 27.5 21.3542 27.5 15.0758Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.cbb78ec1e3295f3b7c365c5b7597683d.svg";
export { ForwardRef as ReactComponent };